import React, {Component} from 'react';
import styled, {keyframes} from 'styled-components';
import {WhenInView} from "../Tools/WhenInView";
import {Check} from 'react-feather';

import {
  Contain,
  HugeTitle,
  InfoParagraph,
  Margin,
  primary,
  ThinLine,
  SmallMargin,
  MediumTitle,
  shadowHover,
  shadowSmall,
  shadow
} from '../Tools/Variables';

const Wrapper = styled.div `
position:relative;
height:500px;
max-width:100%;
margin: 0 15%;
box-sizing:border-box;

background-size:cover;
box-shadow:${shadow};



  
`;

const OfferContainer = styled.div `
float:right;
height:100%;
width:50%;
background:white;

opacity:0.8;



`

class Offer extends Component {
  render() {
    return (
      <Contain>
        <Wrapper>
          <MediumTitle
            style={{
            position: 'absolute',
            top: '-70px',
            color: primary
          }}>Erbjudande (Kommer inte mer 1.0)</MediumTitle>
          <OfferContainer></OfferContainer>
        </Wrapper>
      </Contain>

    );
  }
}

export default Offer;



// WEBPACK FOOTER //
// ./src/Home/Offer.js